import { WitboostCommercialModule } from '../types';

export function mergeArraysWithEmptyCheck<T>(...arrays: T[][]): T[] {
  // Check if any array is empty
  if (arrays.some(array => array.length === 0)) {
    return [];
  }

  // If no arrays are empty, create an array of all unique values
  const allValues = arrays.flat();
  return [...new Set(allValues)];
}

interface ConfigurableField {
  label: string;
  id: string;
  description?: string;
  requiredModules: WitboostCommercialModule[];
}

const configurableField: ConfigurableField[] = [
  {
    id: 'displayNameDescriptorField',
    label: 'Display name',
    description: 'Field used as entity display name in the marketplace section',
    requiredModules: [WitboostCommercialModule.MarketPlane],
  },
];

const wittyConfigurableField: ConfigurableField[] = [
  {
    id: 'wittyConfiguration',
    label: 'Witty',
    description: 'Runtime and provider configuration for Witty assistant',
    requiredModules: [WitboostCommercialModule.Witty],
  },
];

export const getMarketplaceConfigurationRequiredModules =
  (): WitboostCommercialModule[] =>
    mergeArraysWithEmptyCheck(...configurableField.map(f => f.requiredModules));

export const getWittyConfigurationRequiredModules =
  (): WitboostCommercialModule[] =>
    mergeArraysWithEmptyCheck(
      ...wittyConfigurableField.map(f => f.requiredModules),
    );

export const getDynamicConfigRequiredModules = (): WitboostCommercialModule[] =>
  mergeArraysWithEmptyCheck(
    getMarketplaceConfigurationRequiredModules(),
    getWittyConfigurationRequiredModules(),
  );
